<div class="card-principal mb-4" *ngIf="showAgenda">
    <p class="titulo-calendar">Fecha entrega estimada</p>
    <div class="row">
        <div class="col-3">
            <img class="icn-arrow-down" src="assets/icons/calendario.svg">
        </div>
        <div class="col-9">
            <p *ngIf="showAgenda" class="subtitulo-calendar">{{fechaEntrega.nombreDia}} {{fechaEntrega.dia}} de {{fechaEntrega.nombreMes}} </p>
            <p class="horario-calendar"> </p>
        </div>
    </div>
    <!-- <div class="contenedor-btn">
        <button class="btn-secondary-tbk">Añadir a mi calendario</button>
    </div> -->
</div>